export { default } from './PartiuGpGanhador';
